export const silkWidth = 0.1524 / 1000; // default value from rules
export const pinMarkerRadius = silkWidth * 1.5;
export const pinMarkerMargin = silkWidth * 3;
export const designatorMargin = 0.7 / 1000;
export const designatorFontSize = 0.7 / 1000;
export const epadString = "Thermal Pad";
//# sourceMappingURL=commonConstants.js.map